module.exports = __webpack_public_path__ + "static/media/Becky Berentsen Headshot_1610703151624.fb5e8ba0.png";